import { createContext, useContext, useMemo, useState } from "react";

const EventContext = createContext(null);

export function EventProvider({ children }) {
  const [selectedEvent, setSelectedEvent] = useState(null);

  // 互換用（既存コードが eventId を参照している場合に備える）
  const eventDate = selectedEvent?.date ?? "";
  const eventName = selectedEvent?.name ?? "";
  const eventTableKey = selectedEvent?.tableKey ?? "";

  const value = useMemo(
    () => ({
      selectedEvent,
      setSelectedEvent,
      eventDate,
      eventName,
      eventTableKey,
    }),
    [selectedEvent]
  );

  return <EventContext.Provider value={value}>{children}</EventContext.Provider>
}

export function useEvent() {
  const ctx = useContext(EventContext);
  if (!ctx) throw new Error("useEvent must be used within <EventProvider>");
  return ctx;
}